module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAPFBMVEUAAABVVVUcHBwcHBwcHBwbGxsaGhoaGhobGxsbGxsaGhoaGhoaGhoaGhoaGhobGxsbGxsbGxsaGhoaGhrUhBvCAAAAE3RSTlMAAzdSZba3ucjJ1Nfe6vX2+fr+8V0vDgAAAFZJREFUKM9jYKAIMHELowFuJrgklyAnBwrgFOSCSwqxo5vFLgRnCrOiS7IJj0oOuKQALxoQQJLk50ED/KTaycyMW5KRj48Rt04WFkydeBMY3qSJK1EDAMmrCiGk0bY9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/new/index/mobile_icon.png
// module id = 1n1S
// module chunks = 24